//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------
import goodList from '@/components/goodList/index.vue';
export default {
  name: 'GoodListFrom',
  components: {
    goodList: goodList
  },
  data: function data() {
    return {
      handleNum: '',
      visible: false,
      callback: function callback() {},
      checked: []
    };
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getStoreItem: function getStoreItem(img) {
      this.callback(img);
      this.visible = false;
    }
  }
};